import type {SVGProps} from 'react';
import * as React from 'react';
export const InsuranceIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.8}
			d="m6.75 11.053 2.45 3.481a1.049 1.049 0 0 0 1.707.051l7.843-9.927M3 .749a1.5 1.5 0 0 0-1.5 1.5v9c0 4.813 7.234 10.169 9.693 11.76a1.477 1.477 0 0 0 1.614 0c2.459-1.591 9.693-6.947 9.693-11.76v-9a1.5 1.5 0 0 0-1.5-1.5H3Z"
		/>
	</svg>
);
